module.exports = __webpack_public_path__ + "img/questions1.c19b260f.svg";